import { render, staticRenderFns } from "./TopicOptions.vue?vue&type=template&id=541cc854&scoped=true"
import script from "./TopicOptions.vue?vue&type=script&lang=js"
export * from "./TopicOptions.vue?vue&type=script&lang=js"
import style0 from "./TopicOptions.vue?vue&type=style&index=0&id=541cc854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541cc854",
  null
  
)

export default component.exports